export var ProjectLogo;
(function (ProjectLogo) {
    ProjectLogo["INFLOW"] = "Inflow";
})(ProjectLogo || (ProjectLogo = {}));
//# sourceMappingURL=types.js.map